import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { enqueueSnackbar } from "notistack";
import {
  createGeneralAPIEndpoint,
  CenterEndPoints,
  EducationStageEndPoints,
} from "../../../services/General";

export default function Center() {
  const [stages, setStages] = useState([]);

  const [open, setOpen] = useState(false);

  const [editing, setEditing] = useState(null);

  const [educationStages, setEducationStages] = useState([]);

  const [center, setCenter] = useState({
    name: "",
    educationStageId: "",
  });

    const handleChange = (field, value) => {
      setCenter({ ...center, [field]: value });
    };
  useEffect(() => {
     createGeneralAPIEndpoint(EducationStageEndPoints.all)
          .fetch()
          .then((response) => {
            setEducationStages(response.data || []);
          })
          .catch((error) => {
            console.error("Error fetching education stages:", error);
            setEducationStages([]);
          });
    loadStages();
  }, []);

  const loadStages = () => {
    createGeneralAPIEndpoint(CenterEndPoints.all)
      .fetch()
      .then((res) => setStages(res.data))
      .catch(() =>
        enqueueSnackbar("Failed to load stages", {
          variant: "error",
        }),
      );
  };

  const handleOpen = (center = null) => {
    if (center) {
      setEditing(center);

      setCenter({
        name: center.name,
        educationStageId: center.educationStage.id,
      });
    } else {
      setEditing(null);

      setCenter({
        name: "",
        educationStageId: "",
      });
    }

    setOpen(true);
  };

  const handleSave = () => {
    console.log(center)
    if (!center.name || !center.educationStageId) {
      enqueueSnackbar("Please fill all fields", {
        variant: "warning",
      });
      return;
    }

    const request = editing
      ? createGeneralAPIEndpoint(CenterEndPoints.update(editing.id)).put(
          center
        )
      : createGeneralAPIEndpoint(CenterEndPoints.create).postWithToken(center);

    request
      .then(() => {
        enqueueSnackbar(
          editing ? "Updated Successfully" : "Added Successfully",
          {
            variant: "success",
          },
        );

        setOpen(false);

        loadStages();
      })
      .catch(() =>
        enqueueSnackbar("Operation failed", {
          variant: "error",
        }),
      );
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this stage?")) return;

    createGeneralAPIEndpoint(CenterEndPoints.delete(id))
      .delete()
      .then(() => {
        enqueueSnackbar("Deleted Successfully", {
          variant: "success",
        });

        loadStages();
      })
      .catch(() =>
        enqueueSnackbar("Delete Failed", {
          variant: "error",
        }),
      );
  };

  return (
    <Box p={3}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
        className="header"
      >
        <h1 className="header-title">Centers</h1>

        <Button
          startIcon={<AddIcon />}
          onClick={() => handleOpen()}
          className="add-button"
        >
          Add Center
        </Button>
      </Box>

      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fill,minmax(280px,1fr))"
        gap={2}
        className="centers-grid"
      >
        {stages.map((center) => (
          <Card key={center.id}>
            <CardContent>
              <h2 className="center-name">{center.name}</h2>

              <Box className="center-actions">
                <IconButton
                  color="primary"
                  onClick={() => handleOpen(center)}
                  className="edit-button"
                >
                  <EditIcon />
                </IconButton>

                <IconButton
                  color="error"
                  onClick={() => handleDelete(center.id)}
                  className="delete-button"
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
        className="center-dialog"
      >
        <DialogTitle>{editing ? "Edit Center" : "Add Center"}</DialogTitle>

        <DialogContent dividers>
          <TextField
            fullWidth
            select
            label="Education Stage"
            margin="normal"
            value={center.educationStageId}
            onChange={(e) => handleChange("educationStageId", e.target.value)}
            className="arabic-name-field"
          >
            {educationStages.map((stage) => (
              <MenuItem key={stage.id} value={stage.id} className="li">
                {stage.nameAr} - {stage.nameEn}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            fullWidth
            label="Center Name"
            margin="normal"
            value={center.name}
            onChange={(e) =>
              setCenter({
                ...center,
                name: e.target.value,
              })
            }
            inputProps={{
              dir: "auto",
            }}
            className="arabic-name-field"
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)} className="cancel-button">
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSave}
            className="save-button"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
